import { render, staticRenderFns } from "./IconPuzzleSolid.vue?vue&type=template&id=9efe3726"
import script from "./IconPuzzleSolid.vue?vue&type=script&lang=js"
export * from "./IconPuzzleSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports